import React, { Component } from 'react'
import { FaFacebook, FaInstagram } from 'react-icons/fa'
import { Button, FormControl, InputGroup, Spinner }from 'react-bootstrap'
import '../styles/Footer.css'
import { useInView } from 'react-intersection-observer';

const texts = {
    block1: {
      title: {
        en: 'Address',
        fr: 'Adresse',
      },
      p1: {
        en: 'Phone',
        fr: 'Tel.',
      },
    },
    block2: {
        title: {
          en: 'Site Navigation',
          fr: 'Naviguer notre Site',
        },
        links: {
          en: [
              'Home', 
              'History of Château', 
              'La Croix de Millorit Today', 
              'Visits and Accommodations', 
              'Our Gallery', 
              'The Region', 
              'Our Wines', 
              'How to Find Us', 
              'Contact Us',],
          fr: [
            'Accueil',
            'Historique du Château',
            'La Croix de Millorit de nos jours',
            'Visites et Hébergement',
            'Notre Galerie',
            'La région',
            'Nos vins',
            'Où nous trouver',
            'Nous contacter',
          ],
        },
    },
    block3: {
        title: {
          en: 'Our Newsletters',
          fr: 'Nos Newsletters',
        },
        p1: {
          en: 'Subscribe to stay in touch',
          fr: 'Abonnez-vous',
        },
        p2: {
            en: 'Recipient`s email',
            fr: 'Courriel',
          },
        p3: {
            en: 'SUBSCRIBE',
            fr: 'SOUSCRIRE',
          },
    }
}

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const SubFooterIcons =()=> {
    const { ref, inView } = useInView();
    return(
        <div ref={ref} className="social-links text-center text-md-right pt-3 pt-md-0">
            <a className={`instagram ${animate(inView, 'bounceIn', 0)}`} href="https://www.instagram.com/chateaulacroixdemillorit/" target="_blank" rel="noreferrer"><FaInstagram/></a>
            <a className={`facebook ${animate(inView, 'bounceIn', 1)}`} href="https://www.facebook.com/profile.php?id=100076462575657" target="_blank" rel="noreferrer"><FaFacebook/></a>
        </div>
    )
}

export default class Footer extends Component {
    state = {
        name: 'Subscriber',
        email: '',
        subject: 'Subscription Request',
        message: 'Please add my email to the subscription list.',
        status: 'ready',
        subscribeBtnLbl: texts.block3.p3[this.props.lang]
    }

    componentDidUpdate(nextProps){
        if(nextProps.lang !== this.props.lang){
            this.setState({
                subscribeBtnLbl: texts.block3.p3[this.props.lang]
            })
        }
    }

    handleClickSend =()=> {
        this.setState({status: 'process'});
        const mailData = {
            name: this.state.name,
            email: this.state.email,
            subject: this.state.subject,
            message: this.state.message,
        }

        fetch('/api/email', {
            method: 'POST',
            headers: {
              'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailData)
          }).then((res) => {
                res.json().then((body) => {
                    console.log(body)
                    setTimeout(()=>{
                        this.setState({subscribeBtnLbl: 'DONE', status: 'sent'})
                    }, 1000)
                });
          })
    }

    render() {
    return (
        <footer id="footer" >
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 footer-contact">
                            <h4>{texts.block1.title[this.props.lang]}</h4>
                            <p>
                            Château La Croix de Millorit <br/>
                            2 Route De La Corniche <br/> 
                            33710 Bayon sur Gironde <br/>
                            France <br/>
                            <strong>{texts.block1.p1[this.props.lang]}:</strong> +33 6 6307 5398<br/>
                            </p>
                        </div>

                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4 className="footer-nav-title">{texts.block2.title[this.props.lang]}</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"></i> <a href="#">{texts.block2.links[this.props.lang][0]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#chateau">{texts.block2.links[this.props.lang][1]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#chateau2">{texts.block2.links[this.props.lang][2]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#visit">{texts.block2.links[this.props.lang][3]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#gallery">{texts.block2.links[this.props.lang][4]}</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4 className="footer-nav-title"></h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"></i> <a href="#wine">{texts.block2.links[this.props.lang][5]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#wine2">{texts.block2.links[this.props.lang][6]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#contacts">{texts.block2.links[this.props.lang][7]}</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#contactus">{texts.block2.links[this.props.lang][8]}</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-md-6 footer-newsletter">
                            <h4>{texts.block3.title[this.props.lang]}</h4>
                            <p>{texts.block3.p1[this.props.lang]}</p>
                            <InputGroup className="mb-3">
                                <FormControl
                                    placeholder={texts.block3.p2[this.props.lang]}
                                    aria-label={texts.block3.p2[this.props.lang]}
                                    value={this.state.email}
                                    onChange={(event)=>{this.setState({email: event.target.value})}}
                                    disabled={this.state.status!=='ready'}
                                />
                                <Button 
                                    variant="outline-secondary" 
                                    id="button-addon2" 
                                    onClick={this.handleClickSend}
                                    disabled={this.state.status!=='ready'}
                                    >
                                    {
                                        this.state.status === 'process' ? 
                                            <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className={`spinner ${this.state.status !== 'process' ? 'invisible' : ''}`}
                                            />
                                            : this.state.subscribeBtnLbl
                                    }
                                </Button>
                            </InputGroup>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container d-md-flex py-4">
                <SubFooterIcons/>
            </div>
        </footer>
    );
  }
}